module.exports = __webpack_public_path__ + "static/media/1023273.3550aa5a.png";